import { DialogContent as Mui4DialogContent, DialogContentProps as Mui4DialogContentProps } from '@material-ui/core'
import { styled } from '@mui/material'
import { default as Mui5DialogContent } from '@mui/material/DialogContent'
import { forwardRef } from 'react'
import { useComponentVersion } from '../hooks'
import { OsDialogVersion } from './Dialog'

const StyledDialogContent = styled(Mui5DialogContent)<{ margin?: 'normal' | 'none' }>(({ margin }) => {
  return {
    padding: margin === 'normal' ? '20px' : '0px',
  }
})

export type DialogContentProps = Mui4DialogContentProps & {
  margin?: 'normal' | 'none'
}
/** @deprecated Use DialogContentProps */
export type OsDialogContentProps = DialogContentProps

export const DialogContent = forwardRef<HTMLDivElement, DialogContentProps>(({ margin = 'normal', ...props }, ref) => {
  const version = useComponentVersion('dialog')
  switch (version) {
    case OsDialogVersion.V2:
      return <StyledDialogContent ref={ref} {...props} margin={margin} />

    default:
      return <Mui4DialogContent ref={ref} {...props} />
  }
})
